import { Component, OnInit, Renderer2, Input, ViewEncapsulation, Inject, ViewChild, ElementRef, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { BreadcrumbService } from '../breadcrumb/breadcrumb.service';
import { DashboardService } from './dashboard.service';
import { BreadcrumbLink } from '../../models/Breadcrumb';
import { HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AdminService } from '../../../admin/admin.service';
import { Control } from '../../models/model-year';
import _ from 'lodash';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { VehicleFeature } from '../../models/vehicle-feature';
import { PhoneManufacturerService } from '../phone-manufacturer/phone-manufacturer.service';
import { HeadUnitPayload } from '../../models/headunit-payload';
import { LoaderService } from '../../loader/loader.service';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { PopoutService } from '../../services/tccp-popout.service';
import { POPOUT_MODAL_DATA, POPOUT_MODALS, PopoutData, PopoutModalName } from '../../services/tccp-popout.token';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class DashboardComponent implements OnInit {
  public features: Control[] = [];
  public audioFeatures: Control[] = [];
  public connectedFeatures: Control[] = [];
  public initialPath = '';
  public previewFlow = false;
  public orderSPData = [];
  public vehicleVIN = this.storageService.getVehicleVin();
  public vehicleGeneration = this.storageService.getVehicleGeneration();
  public firstSetupPath = '';
  @Input() feature: Control[];
  @ViewChild('driveConnect1', { static: false }) public driveConnectRef: ElementRef;
  windowWidth: any;

  constructor(
    private commonService: TCCPCommonService,
    private popoutService: PopoutService,
    private breadcrumbService: BreadcrumbService, private router: Router,
    private dashboardService: DashboardService, private dialog: MatDialog,
    public storageService: TCCPLocalStorageService,
    private phoneManufacturerService: PhoneManufacturerService,
    private loaderService: LoaderService,
    private renderer: Renderer2, private adminService: AdminService, private sanitizer: DomSanitizer) {
    this.getScreenSize();
    this.getSupportTopicOrder();
  }

  public appName = environment.applicationName;
  public notes = 'Disclaimer: Not all features are available on all vehicles and model grades.';
  private appBase = TCCPConstantValues[this.appName];
  public isInternal = false;
  public isVehicleFound = false;
  public hideCapability = ['Can300', 'NavigationTrafficProbe'];
  public vehicleDetails = [];
  public showVINDetails = false;
  public showVINImage = false;
  public vinCapabilityDetails = [];
  public remoteCapabilityDetails = [];
  public showDriveDetails = false;
  public hideRemoteCapabilities = true;
  public hideCapabilities = true;
  public vinImage = null;
  public isCategoryMapping = false;
  public tip = 'We are sorry.  \n This Support Topic is currently under maintenance. \n Please check back in a few hours.';
  public isToyota: boolean;
  public tileElevationIndex: number[] = [-1, -1];
  public tileElevationStyles: any;
  public draftImageUrl: string;
  phoneManufacturerList: any;
  public huConfigList: number[] = [];
  public phoneModelWithHUCofigList = [];
  public selectedPhoneConfigId: any;
  public phoneHUConfigInfoList = [];
  public vin = '';
  public telematicsMPC = '';
  public newBannerImageURL = `${environment.baseURL}content/${this.appName}/common/new_Banner.png`;
  public dashCardBackArrowURL = `${environment.baseURL}content/${this.appName}/common/backArrow.png`;
  public dashCardBNextArrowURL = `${environment.baseURL}content/${this.appName}/common/nextArrow.png`;
  public backImgUrl = `${environment.baseURL}content/${this.appName}/common/firstGuideBanner_Img.png`;
  public categories:string[] = ['audioFeatures','connectedFeatures'];

  getSupportTopicOrder() {
    this.commonService.getCategoryMapping(environment.applicationName).subscribe(data => {
      if (data) {
        this.orderSPData = data;
      }
    });
  }

  setSupportTopicCategoryOrder() {
    let isOrderMappingExists = false;
    this.orderSPData.forEach(x => {
      this.features.forEach(y => {
        if (x.issueId === y[`issueId`]) {
          if (!isOrderMappingExists) {
            isOrderMappingExists = true;
            this.isCategoryMapping = true;
            const elContent = document.querySelector('.content-block');
            this.renderer.setStyle(elContent, 'background', '#F9F9F9');
          }
        }
      });
    });
    return isOrderMappingExists;
  }

  setSupportTopicCategoryMapping() {
    this.connectedFeatures = [];
    this.audioFeatures = [];
    this.orderSPData.forEach(x => {
      this.features.forEach(y => {
        if (x.issueId === y['issueId']) {
          y.category = x.category;
          y.order = x.order;
          if (this.appName === 'toyota') {
            if (y.category === 'Audio Multimedia') {
              this.audioFeatures.push(y);
            } else if (y.category === 'Connected Services') {
              this.connectedFeatures.push(y);
            }
          } else if (this.appName === 'lexus') {
            if (y.category === 'Lexus Multimedia') {
              this.audioFeatures.push(y);
            } else if (y.category === 'Enform Services') {
              this.connectedFeatures.push(y);
            }
          }
        }
      });
    });
  }

  showDisclaimer() {
    const disclaimerText = `Select a support topic to learn more about your vehicle's multimedia system and Connected Services`;
    const temp = (this.windowWidth < 420 && this.windowWidth > 405) ? '50vw' : 'auto';
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      height: temp,
      data: { type: 'basic', message: disclaimerText }
    });
  }

  hideTooltipIn(tooltip: MatTooltip, ms: number, mouseLoc: boolean, index: number, categoryMappingIndex: number) {
    // mouseLoc -> To know if mouse is over any of the tiles
    // index -> Index of the tile in multimedia/services list
    // categoryMappingIndex -> to differentiate MultiMedia and Services tiles, input param 0=>multimedia, 1=>services
    this.tileElevationIndex = mouseLoc ? (categoryMappingIndex === 0 ? [index, -1] : [-1, index]) : [-1, -1];
    this.tileElevationStyles = mouseLoc ? 'published-scale' : '';
    tooltip.toggle();
    setTimeout(() => tooltip.hide(), ms);
  }

  ngOnInit() {
    /* Resetting the progressbar related details */
    
    const path = environment.applicationName === 'toyota' ? TCCPConstantValues.base.url_contexts.TOYOTA_QUICKGUIDE :
      environment.applicationName === 'lexus' ? TCCPConstantValues.base.url_contexts.LEXUS_QUICKGUIDE : environment.applicationName;
    this.firstSetupPath = this.storageService.getFeatureType() === 'internal' ? `${window.location.origin}/${path}/home/internal` :
      `${window.location.origin}/${path}/home`;
    this.storageService.setProgressBarTracker({});
    this.storageService.setSelectedStepIssueId(null);
    this.storageService.setSelectedStep({});
    this.storageService.setAfterControlStep(false);
    this.storageService.setNestedStep(null);
    this.commonService.hideBreadrumb.emit(false);
    this.isToyota = this.appName === 'toyota' ? true : false;
    document.documentElement.scrollTop = 0;
    this.commonService.enableFeedback = false;
    this.commonService.showFeedback.emit({ showFeedback: false });
    this.storageService.setSupportTopics('Support Topics', this.router.url);
    this.isInternal = this.commonService.setAppFeatureType(this.router.url);
    this.commonService.setGTagPageDetails('Dashboard', `${this.appName}/dashboard`, window.location.href);
    this.commonService.clearDashboardPage.subscribe((data) => {
      if (data === 'SUPPORTTOPICS') {
        this.breadcrumbService.clearBreadcrumb.emit(true);
        this.breadcrumbService.showBreadcrumb.emit(true);
      }
    });
    this.storageService.setPreview(false);
    this.initialPath = this.router.url;
    this.storageService.setFeature(null, null);
    this.storageService.setSubTopic(null, null);
    this.storageService.clearFlow();
    if (this.feature) {
      this.features = this.feature;
      const isOrderMappingExists = this.setSupportTopicCategoryOrder();
      if (isOrderMappingExists) {
        // this.setSupportTopicCategoryMapping();
        if (this.connectedFeatures.length === 0 && this.audioFeatures.length === 0) {
          this.isCategoryMapping = false;
        }
      }
    } else {
      this.previewFlow = false;
      const elContent = document.querySelector('.content-block');
      if (this.isCategoryMapping) {
        this.renderer.setStyle(elContent, 'background', '#F9F9F9');
      }
      this.commonService.setBackground(this.renderer, this.appName);
      this.loaderService.show();
      const vehicleVIN = this.storageService.getVehicleVin();
      // OneApp Redirection
      if (!_.isEmpty(vehicleVIN) && !_.isEmpty(vehicleVIN.name) && _.isNil(this.commonService.vinDetails)) {
        const capabilityArray: Array<string> = [];
        this.commonService.getVehicleInfo(this.storageService.getVehicleVin().name).subscribe(vinData => {
          this.commonService.vinDetails = vinData;
          this.storageService.setModelCode(_.get(vinData, 'summary.vehicleSummary.modelCode'));
          this.commonService.vinSummaryDetails = vinData;
          const modelVehicleDesc = _.get(vinData, 'summary.vehicleSummary.modeldescription');
          const modelYearFromVin = _.get(vinData, 'summary.vehicleSummary.modelYear');
          this.storageService.setVehicleModelName(modelVehicleDesc);
          this.storageService.setVehicleModelYear(modelYearFromVin);
          this.storageService.setVehicleYear(modelYearFromVin, `/${this.appName}/home`);
          if (!_.isNil(_.get(vinData, 'vehicleCapabilities.capabilities'))) {
            _.get(vinData, 'vehicleCapabilities.capabilities').forEach(capability => {
              if (_.get(capability, 'value')) {
                const vCapability = _.lowerCase(_.get(capability, 'name'));
                capabilityArray.push(vCapability.replace(/\s+/g, ''));
              }
            });
          }
          /*capability only required to be set in the request */
          const requestData: VehicleFeature = {
            division: this.appName === 'toyota' ? 'Toyota' : 'Lexus',
            type: this.storageService.getFeatureType() === 'internal' ? this.storageService.getFeatureType() : 'external',
            capabilitiy: capabilityArray
          };
          const feats: Array<string> = [];
          if (!_.isEmpty(capabilityArray)) {
            // Retrieve support topic based on CVS Capability
            this.commonService.getFilteredFeatures(requestData).subscribe(features => {
              // Set Array of support Topic in storage
              const feat: Array<string> = features.toString().split(',');
              feat.forEach(feature => {
                feats.push(feature.replace(/\s/g, ''));
              });
              this.storageService.setMappedFeatures(feats);
            });
          }

          this.commonService.getmodelName().subscribe(data => {
            data.forEach((element, index) => {
              if (!_.isEmpty(vehicleVIN) && !_.isEmpty(vehicleVIN.name)) {
                if (modelVehicleDesc && modelVehicleDesc !== undefined &&
                  encodeURIComponent(modelVehicleDesc).replace('-', '').toUpperCase()
                    .indexOf(encodeURIComponent(element.model).toUpperCase()) !== -1) {
                  this.storageService.setVehicleModel(encodeURIComponent(element.model), `/${this.appName}/home`);
                  this.storageService.setVehicleModelName(encodeURIComponent(element.model));
                  this.storageService.setVehicleYear(Number(modelYearFromVin), `/${this.appName}/home`);
                  this.storageService.setVehicleModel(encodeURIComponent(element.model), `/${this.appName}/home`);
                  this.breadcrumbService.showBreadcrumb.emit(true);
                }
              } else {
                if (encodeURIComponent(element.model) === this.storageService.getVehicleModel().name) {
                  this.storageService.setVehicleModel(encodeURIComponent(element.model), `/${this.appName}/home`);
                  this.storageService.setVehicleModelName(encodeURIComponent(element.model));
                }
              }
            });
          });
        });
      }

      /* Model Data from storage */
      if (!_.isEmpty(this.storageService.getModels() && _.isNil(this.storageService.getVehicleModelName()))) {
        this.storageService.getModels().forEach(element => {
          if (_.includes(_.get(element, 'modelCodes'), this.storageService.getModelCode())) {
            this.storageService.setVehicleModelName(_.get(element, 'model'));
          }
        });
      }

      /* Setting Model Name in storage for Bluetooth Compatability - remove below code if no impact*/
      this.commonService.getmodelName().subscribe(data => {
        data.forEach(element => {
          if (element.model === this.storageService.getVehicleModel().name) {
            const gen = element.years.find(data => {
              return `${data.year}` === `${this.storageService.getVehicleYear().name}`;
            });
            this.storageService.setVehicleGeneration(gen.generation, this.router.url);
            this.vehicleGeneration = gen.generation;
            this.storageService.setVehicleModelName(element.model);
          }
        });
      });
      let vehicleModel: any = this.storageService.getVehicleModel() ? this.storageService.getVehicleModel().name || this.storageService.getVehicleModelName() : null;
      let vehicleYear: any = this.storageService.getVehicleYear() ? this.storageService.getVehicleYear().name : null;
      if (vehicleVIN && vehicleVIN.name) {
        vehicleModel = !_.isEmpty(this.storageService.getVehicleModelName()) ?
          this.storageService.getVehicleModelName() : this.storageService.getVehicleModel().name;
        vehicleYear = !_.isEmpty(this.storageService.getVehicleModelYear()) ?
          this.storageService.getVehicleModelYear() : this.storageService.getVehicleYear().name;
      }
      this.retrieveFeaturesToDashboard(vehicleModel, vehicleYear, vehicleVIN);
    }
  }

  public retrieveFeaturesToDashboard(vehicleModel, vehicleYear, vehicleVIN) {
    this.commonService.hideModelYearSection.emit(true);
    this.commonService.hideBreadrumb.emit(false);
    if (vehicleModel.includes('%20')) {
      vehicleModel = vehicleModel.replace('%20', ' ');
      const homeURL = this.storageService.getFeatureType() === 'internal' ? `${this.appName}/home/internal` :
        `${this.appName}/home`;
      this.storageService.setVehicleModel(vehicleModel, homeURL);
    }
    this.storageService.setNestedStep(null);
    this.dashboardService.getFeature(vehicleModel, parseInt(vehicleYear, 10),
      this.storageService.getFeatureType()).subscribe(data => {
        const filteredFeatures: Control[] = [];
        if (!_.isEmpty(vehicleVIN) && !_.isEmpty(vehicleVIN.name) && _.isNil(this.commonService.vinDetails)) {
          this.commonService.getVehicleInfo(this.storageService.getVehicleVin().name).subscribe(vinData => {
            this.commonService.vinDetails = vinData;
          });
        }
        if (data && data instanceof Array && data.length > 0) {
          if (!vehicleVIN || vehicleVIN === undefined) {
            this.features = data[0].controls;
            const isOrderMappingExists = this.setSupportTopicCategoryOrder();
            if (isOrderMappingExists) {
              this.setSupportTopicCategoryMapping();
              if (this.connectedFeatures.length === 0 && this.audioFeatures.length === 0) {
                this.isCategoryMapping = false;
              }
            }
          } else {
            if (!_.isEmpty(vehicleVIN.name)) {
              if (this.commonService.vinDetails) {
                const vinData = this.commonService.vinDetails;
                this.setVINImageDetails(vinData);
              } else {
                this.commonService.getVehicleInfo(vehicleVIN.name).subscribe(vinData => {
                  if (vinData) {
                    this.setVINImageDetails(vinData);
                  }
                });
              }
              this.features = data[0].controls;
              const isOrderMappingExists = this.setSupportTopicCategoryOrder();
              if (isOrderMappingExists) {
                this.setSupportTopicCategoryMapping();
                if (this.connectedFeatures.length === 0 && this.audioFeatures.length === 0) {
                  this.isCategoryMapping = false;
                }
              }

              this.features.forEach(x => {
                if (x.controlName !== 'Bluetooth® Phone Compatibility') {
                  this.storageService.setBTFeatAvailable(true);
                }
                console.log('befoe isgeneric check ', this.features);
                if (_.get(x, 'isGeneric')) {
                  filteredFeatures.push(x);
                }

                if (_.includes(this.storageService.getMappedFeatures(), _.get(x, 'featureName').replace(/\s/g, ''))) {
                  filteredFeatures.push(x);
                }
              });
              console.log('this.storageService.getMappedFeatures()', this.storageService.getMappedFeatures());
              console.log('befoe isgeneric check ', filteredFeatures);
              this.features = [];
              filteredFeatures.forEach(x => {
                this.features.push(x);
              });
              this.setSupportTopicCategoryMapping();
            } else {
              console.log(this.storageService.getVehicleYear());
              this.features = data[0].controls;
              const isOrderMappingExists = this.setSupportTopicCategoryOrder();
              if (isOrderMappingExists) {
                this.setSupportTopicCategoryMapping();
                if (this.connectedFeatures.length === 0 && this.audioFeatures.length === 0) {
                  this.isCategoryMapping = false;
                }
              }
            }
            const currentYear = (new Date()).getFullYear();
            const minYear = currentYear - 4;
            this.features = _.uniq(this.features);
            if(parseInt(this.storageService.getVehicleYear().name) < minYear){
              this.features.forEach((cntrl,index) => {
                console.log(cntrl);
                if (cntrl.controlName === "Bluetooth® Pairing") {
                  this.features.splice(index,1);
                }
              });
            };

            // Redirect user to Home Page if no features to display
            if (_.isEmpty(this.features)) {
              this.commonService.hideBreadrumb.emit(false);
              this.commonService.hideModelYearSection.emit(false);
              const url = this.storageService.getFeatureType() === 'internal' ? `/${this.appName}/home/internal` : `/${this.appName}/home`;
              this.router.navigate([url]);
            }
          }
          this.commonService.selectedFeature = <BreadcrumbLink>({ name: '', link: '' });
          this.breadcrumbService.clearBreadcrumb.emit(true);
          this.breadcrumbService.showBreadcrumb.emit(true);
          this.commonService.changeLayoutStyle.emit(true);
          this.commonService.hideBreadrumb.emit(false);
          this.loaderService.hide();
        } else {
          // Default to home page
          this.commonService.hideBreadrumb.emit(false);
          this.commonService.hideModelYearSection.emit(false);
          this.router.navigate([`/${this.appName}/home`]);
        }
      });
  }

  getPayload(vin) {
    let requestData: HeadUnitPayload;
    if (_.isNil(vin) || _.isEmpty(vin)) {
      requestData = {
        headUnitConfigArray: this.huConfigList,
        modelName: this.storageService.getVehicleModelName(),
        mpc: '',
        mpcOption: false,
        year: this.storageService.getVehicleYear().name
      };
    } else {
      requestData = {
        headUnitConfigArray: [],
        modelName: '',
        modelCode: this.storageService.getModelCode(),
        mpc: this.storageService.getMPCCode(),
        mpcOption: true,
        year: this.storageService.getVehicleYear().name
      };
    }
    return requestData;
  }


  showActive(e, status) {
    if (e.target && status !== 'draft') {
      e.target.classList.add('active');
    } else {
      console.log(e.target.classList);
      e.target.classList.remove('active');
      e.target.classList.remove('cursor');
    }
  }
  showInactive(e) {
    if (e.target) {
      e.target.classList.remove('active');
    }
  }

  imgStyleObject(): Object {
    this.backImgUrl = `${environment.baseURL}content/${this.appName}/common/firstGuideBanner_Img.png`;
    if(this.appName === 'toyota'){
    if (this.windowWidth > 1072  ){
      return {
        background: `url(${this.backImgUrl})`, 
        "background-position": 'right'
      }
       
    }
    else if (this.windowWidth > 768){
      return {
        background: `url(${this.backImgUrl})`, 
        "background-position": 80+'%'
      }
    }
    else if (this.windowWidth > 600){
      return {
        background: `url(${this.backImgUrl})`, 
        "background-position": 70+'%'
      }
    }
    this.backImgUrl = `${environment.baseURL}content/${this.appName}/common/mobile_firstGuideBanner_Img.png`;
    return {
      background: `url(${this.backImgUrl})`,
      "background-position": 90+'% -50px'
    }
  }
  //Lexus image
  else{
    if (this.windowWidth > 1205  ){
      return {
        background: `url(${this.backImgUrl})`, 
        "background-position": 'left',
        "background-size": 150+'vw',

      }
       
    }
    else if (this.windowWidth > 918){
      return {
        background: `url(${this.backImgUrl})`, 
        "background-position": 'left',
        "background-size": 150+'vw inherit',
        "background-repeat": 'no-repeat'
      }
    }
    else if (this.windowWidth > 600){
      return {
        background: `url(${this.backImgUrl})`, 
        "background-position": 'left',
        "background-size": 250+'vw',
        "background-repeat": 'no-repeat'      
      }
    }
    this.backImgUrl = `${environment.baseURL}content/${this.appName}/common/mobile_firstGuideBanner_Img.png`;
    return {
      background: `url(${this.backImgUrl})`,
      "background-position": 12+'% -30px'
    }
  }
}

  setVINImageDetails(vinData) {
    const vinJSON = {
      VIN: 'vin', Model: 'modeldescription', Year: 'modelYear', Color: 'marketingColor',
      'Subscription Status': 'vehicleStatus'
    };
    Object.keys(vinJSON).forEach((vinObj) => {
      Object.keys(vinData.summary.vehicleSummary).forEach((key, index) => {
        this.vinImage = vinData.summary.vehicleSummary.stockPicReference;
        if (vinJSON[vinObj] === key) {
          this.vehicleDetails.push({ name: vinObj, value: vinData.summary.vehicleSummary[key] });
        }
      });
    });
    if (vinData && vinData.subscription) {
      if (vinData.subscription.vehicleStatus || vinData.subscription.status) {
        const subscriptionStatus = _.isNil(vinData.subscription.vehicleStatus) ? vinData.subscription.status
          : vinData.subscription.vehicleStatus;
        this.vehicleDetails.push({
          name: 'Subscription status', value: vinData &&
            vinData.subscription && subscriptionStatus
        });
      }
    }
    if (vinData && vinData.vehicleCapabilities && vinData.vehicleCapabilities.capabilities) {
      this.vinCapabilityDetails = vinData.vehicleCapabilities.capabilities.filter(x => !_.includes(this.hideCapability, x.name));
      this.vinCapabilityDetails = _.filter(this.vinCapabilityDetails, x => x.value);
      this.vinCapabilityDetails = _.uniqBy(this.vinCapabilityDetails, 'displayName');
      this.vinCapabilityDetails = _.filter(this.vinCapabilityDetails, x => x.displayName);
      this.remoteCapabilityDetails = vinData.vehicleCapabilities.extendedCapabilities.remoteCapabilities.filter(x => x.value === true);
      for (let i in this.remoteCapabilityDetails) {
        let temp = this.splitCamelCase(this.remoteCapabilityDetails[i].name);
        this.remoteCapabilityDetails[i].name = temp;
      }
    }
  }

  splitCamelCase(str) {
    return str.split(/(?=[A-Z])/).map((substr) => {
      return substr.charAt(0).toUpperCase() + substr.slice(1);
    }).join(' ');
  }

  public sideScroll(direction, cat) {
    const container = document.getElementById('horizontal-scrolling-wrapper-'+cat);
    if (direction == 'left') {
      container.scrollLeft += 100;
    } else {
      container.scrollLeft -= 100;
    }
  }

  getUrl(icon) {
    return this.appBase.Urls.SVG_PATH + icon;
  }

  onVehicleImageOverlayClick() {
    this.hideCapabilities = true;
    const vinOverlayEl = 'vin-overlay';
    document.getElementById(vinOverlayEl).style.display = 'none';
    this.showVINDetails = false;
  }

  public getDriveConnectClassName(controlName) {
    const convertedControlName = controlName && controlName !== '' && controlName !== undefined ?
      controlName.toLowerCase().trim() : controlName;
    if (this.vehicleGeneration.name === '21MM' && controlName !== undefined && controlName &&
      controlName !== '' && (convertedControlName === 'INTELLIGENT ASSISTANT'.toLowerCase() ||
        convertedControlName === 'DESTINATION ASSIST'.toLowerCase().trim() ||
        convertedControlName === 'CLOUD NAVIGATION'.toLowerCase().trim())) {
      let idName = ''; let className = '';
      if (controlName && controlName !== '' && controlName !== undefined) {
        idName = controlName.replace(/\s/g, '').toLowerCase() + 'supporttopic';
        const el = document.querySelector('.' + idName);
        const elHeight = el.clientHeight;
        if (elHeight < 50 && this.windowWidth < 768) {
          className = 'drive-connect-new-class';
        }
      }
      return className;
    } else {
      return '';
    }
  }

  public getSupportTopicClassName(controlName, type) {
    const convertedControlName = controlName && controlName !== '' && controlName !== undefined ?
      controlName.toLowerCase().trim() : controlName;
    if (this.vehicleGeneration.name === '21MM' && controlName !== undefined && controlName &&
      controlName !== '' && (convertedControlName === 'INTELLIGENT ASSISTANT'.toLowerCase() ||
        convertedControlName === 'DESTINATION ASSIST'.toLowerCase().trim() ||
        convertedControlName === 'CLOUD NAVIGATION'.toLowerCase().trim())) {
      let className = '';
      if (controlName && controlName !== '' && controlName !== undefined) {
        className = type === 'text' ? controlName.replace(/\s/g, '').toLowerCase() + 'supporttopic' :
          controlName.replace(/\s/g, '').toLowerCase() + 'supporttopicimage';
      } else {
        className = '';
      }
      return className;
    } else {
      return '';
    }
  }

 

  public driveConnectAction(controlName, eventName) {
    const convertedControlName = controlName.replace(/\s/g, '').toLowerCase();
    const className = controlName ? convertedControlName + 'supporttopic' : '';
    const imgClassName = controlName ? convertedControlName + 'supporttopicimage' : '';
    const elContent = document.querySelector('.' + className);
    const elImage = document.querySelector('.' + imgClassName);
    if (eventName === 'enter') {
      this.renderer.removeClass(elContent, 'published-hightlight-text');
      this.renderer.removeClass(elImage, 'published-scale');
    } else {
      this.renderer.addClass(elContent, 'published-hightlight-text');
      this.renderer.addClass(elImage, 'published-scale');
    }
  }

  public driveConnectActionOut(input: { controlName: string; eventName: any; }) {
    const controlName = input.controlName;
    const eventName = input.eventName;
    const convertedControlName = controlName.replace(/\s/g, '').toLowerCase();
    const className = controlName ? convertedControlName + 'supporttopic' : '';
    const imgClassName = controlName ? convertedControlName + 'supporttopicimage' : '';
    const elContent = document.querySelector('.' + className);
    const elImage = document.querySelector('.' + imgClassName);
    if (eventName === 'enter') {
      this.renderer.removeClass(elContent, 'published-hightlight-text');
      this.renderer.removeClass(elImage, 'published-scale');
    } else {
      this.renderer.addClass(elContent, 'published-hightlight-text');
      this.renderer.addClass(elImage, 'published-scale');
    }
  }

  public driveConnectMouseEnter(event, controlName) {
    event.preventDefault();
    this.driveConnectAction(controlName, 'enter');
  }

  public driveConnectMouseLeave(event, feature) {
    const controlName = feature.controlName;
    event.preventDefault();
    if (feature.status && feature.status === 'published') {
      this.driveConnectAction(controlName, 'leave');
    }
  }

  onDriveConnectTextClick(event, flag) {
    event.preventDefault();
    this.showDriveDetails = flag;
  }

  onVehicleImageClick(showOverlay: boolean, flag?: boolean) {
    this.hideCapabilities = true;
    const vinOverlayEl = 'vin-overlay';
    document.getElementById(vinOverlayEl).style.display = 'none';
    if (flag) {
      this.showVINDetails = false;
    } else {
      this.showVINDetails = !this.showVINDetails;
      if (showOverlay) {
        const property = this.showVINDetails ? 'block' : 'none';
        document.getElementById(vinOverlayEl).style.display = property;
      }
    }
  }

  ngAfterViewChecked() {
    this.commonService.landingPage = false;
    this.vehicleGeneration = this.storageService.getVehicleGeneration();
  }

  public toggleCapabilities(capabilities) {
    if (capabilities === 'remoteCapabilityDetails') {
      this.hideRemoteCapabilities = !this.hideRemoteCapabilities;
    } else if (capabilities === 'vinCapabilityDetails') {
      this.hideCapabilities = !this.hideCapabilities;
    }
  }

  public scrollTopInImage() {
    const el = document.getElementById('vin-container-wrapper');
    const topPos = el.offsetTop;
    el.scrollTop = topPos;
  }

  public goBack() {
    this.router.navigate([this.storageService.getVehicleYear().link]);
  }

  public onFeatureSelection(feature) {
    this.storageService.setFromDashboard(true);
    const gModel = this.storageService.getVehicleModelName();
    const gYear = this.storageService.getVehicleYear().name;
    this.storageService.setProgressBar(feature.hideProgressBar);
    this.storageService.setFeature(feature.controlName.toLowerCase(), `/${this.appName}/feature/${encodeURIComponent(feature.controlName)}/${feature.targetId}?model=${encodeURIComponent(gModel)}&year=${gYear}`);
    this.storageService.setSelectedFeatureId(feature.targetId);
    this.commonService.selectedFeature = <BreadcrumbLink>({
      name: feature.controlName.toLowerCase() || this.storageService.getFeature(),
      link: `${this.appName}/dashboard`
    });
    if (feature.conrolName !== '' && feature.featureName.indexOf('21MM') !== -1) {
      this.commonService.setGTagEventDetails('Feature', `21MM ${feature.controlName}`, 'Features Clicked');
      this.commonService.setGTagEventDetails('ModelYearFeature', `21MM ${feature.controlName} | m=${gModel} y=${gYear}`,
        'ModelYearFeatures Clicked');
    } else if (feature.controlName !== '') {
      this.commonService.setGTagEventDetails('Feature', '' + feature.controlName, 'Features Clicked');
      this.commonService.setGTagEventDetails('ModelYearFeature', `${feature.controlName} | m=${gModel} y=${gYear}`,
        'ModelYearFeatures Clicked');
    }
    this.adminService.featureName = feature.controlName;
    const stepID: string[] = [];
    stepID.push(feature.targetId);
    this.storageService.setFlow(stepID);
    if (this.feature) {
      this.previewFlow = feature.targetId ? true : false;
    } else {
      const url = [this.appName + '/feature/'
        + (feature.controlName)
        + '/' + feature.targetId] + '?model=' + this.storageService.getVehicleModelName()
        + '&year=' + this.storageService.getVehicleYear().name;
      if (feature.controlName === 'Bluetooth® Pairing' && !gModel.toLowerCase().includes('subaru')) {
        this.loaderService.show();
        const selectedVin = this.storageService.getVehicleVin() === undefined ? this.storageService.setVehicleVin(null, null) :
          this.storageService.getVehicleVin();
        if (this.storageService.getVehicleVin().name !== '') {
        const requestData = this.getPayload(selectedVin['name']);
        this.phoneManufacturerService.getHUConfigList(requestData).subscribe(resultData => {
          if (resultData.data.headUnits) {
            resultData.data.headUnits.forEach((data) => {
              this.huConfigList.push(data.huConfigId);
            });
            this.phoneManufacturerService.getManufaturerList(this.huConfigList)
              .subscribe(data => {
                if (data) {
                  const flag = _.get(data, 'type') === 'Data Exception' ? false : true;
                  this.storageService.setShowBluetoothComp(flag);
                }
                this.loaderService.hide();
                this.router.navigateByUrl(url);
              });
          } else {
            this.storageService.setShowBluetoothComp(true);
            this.router.navigateByUrl(url);
          }
        });
      } else {
        this.storageService.setShowBluetoothComp(true);
        this.router.navigateByUrl(url);
      }
    }
      else {
        this.router.navigateByUrl(url);
    }
  }
}

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.windowWidth = window.innerWidth;
  }

  showNewIcon(feature) {
    const currentDate = new Date(new Date().toUTCString());
    if (feature.firstPublishedDate !== undefined && feature.firstPublishedDate &&
      feature.firstPublishedDate !== '' && feature.status === 'published') {
      const uploadDate = new Date(feature.firstPublishedDate);
      const datediff = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(),
        currentDate.getDate()) - Date.UTC(uploadDate.getFullYear(), uploadDate.getMonth(), uploadDate.getDate())) / (1000 * 60 * 60 * 24));
      if (datediff < 30) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  checkDriveConnectExistence(feature) {
    const convertedControlName = feature.controlName && feature.controlName !== '' &&
      feature.controlName !== undefined ? feature.controlName.toLowerCase().trim() : feature.controlName;
    const isDriveConnectSPExists = this.features.some(x => x.controlName !== undefined && x.controlName &&
      x.controlName !== '' && (x.controlName.toLowerCase() === 'INTELLIGENT ASSISTANT'.toLowerCase() ||
        x.controlName.toLowerCase() === 'DESTINATION ASSIST'.toLowerCase() ||
        x.controlName.toLowerCase() === 'CLOUD NAVIGATION'.toLowerCase()));
    let isDriveConnectExists = false;
    if (this.vehicleGeneration.name === '21MM' && feature.controlName !== undefined && feature.controlName &&
      feature.controlName !== '' && (convertedControlName === 'INTELLIGENT ASSISTANT'.toLowerCase() ||
        convertedControlName === 'DESTINATION ASSIST'.toLowerCase() ||
        convertedControlName === 'CLOUD NAVIGATION'.toLowerCase())) {
      isDriveConnectExists = true;
    }
    if (isDriveConnectSPExists) {
      return isDriveConnectExists ? false : true;
    } else {
      return false;
    }
  }

  showDriverConnectText(feature) {
    const convertedControlName = feature.controlName && feature.controlName !== '' &&
      feature.controlName !== undefined ? feature.controlName.toLowerCase().trim() : feature.controlName;
    if (this.vehicleGeneration.name === '21MM' && feature.controlName !== undefined && feature.controlName &&
      feature.controlName !== '' && (convertedControlName === 'INTELLIGENT ASSISTANT'.toLowerCase() ||
        convertedControlName === 'DESTINATION ASSIST'.toLowerCase() || convertedControlName === 'CLOUD NAVIGATION'.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  }

  openDriveConnectPopup(event, controlName) {
    event.preventDefault();
    event.stopPropagation();
    const ele = document.getElementById(`${controlName}driveConnect`);
    const dialogRef = this.dialog.open(DriveConnectDialogComponent, {
      width: this.windowWidth && this.windowWidth > 768 ? this.windowWidth > 1800 ? '45vw' : '450px' : '85vw',
      height: window.innerWidth && window.innerWidth > 768 ? 'auto' : '300px',
      position: { top: '50px' },
      hasBackdrop: true,
      id: this.appName + '-drive-connect-popup',
      data: { positionRelativeToElement: ele }
    });
  }

  openDriveConnectPopupOut(input: { event: any; controlName: string; }) {
    
    const event = input.event;
    const controlName = input.controlName;
    console.log('driveConnect clicked '+event+' controlName: '+controlName);
    event.preventDefault();
    event.stopPropagation();
    const ele = document.getElementById(`${controlName}driveConnect`);
    const dialogRef = this.dialog.open(DriveConnectDialogComponent, {
      width: this.windowWidth && this.windowWidth > 768 ? this.windowWidth > 1800 ? '45vw' : '450px' : '85vw',
      height: window.innerWidth && window.innerWidth > 768 ? 'auto' : '300px',
      position: { top: '50px' },
      hasBackdrop: true,
      id: this.appName + '-drive-connect-popup',
      data: { positionRelativeToElement: ele }
    });
  }

  closeDriveConnectPopup() {
    this.dashboardService.closeDriveConnect.emit('close');
  }

  @HostListener('window:beforeunload', ['$event'])
  onWindowClose(event: Event) {
    this.popoutService.closePopoutModal();
  }

  openCustomerPopout(name: string) {
    const modalData = {
      modalName: 'PopoutModalName.customerDetail',
      division: environment.applicationName
    };

    if (!this.popoutService.isPopoutWindowOpen()) {
      this.popoutService.openPopoutModal(modalData);
    } else {
      const sameCustomer = POPOUT_MODALS['componentInstance'].name === name;
      if (sameCustomer) {
        this.popoutService.focusPopoutWindow();
      } else {
        POPOUT_MODALS['outlet'].detach();
        const injector = this.popoutService.createInjector(modalData);
        const componentInstance = this.popoutService.attachCustomerContainer(POPOUT_MODALS['outlet'], injector);
        POPOUT_MODALS['componentInstance'] = componentInstance;
        this.popoutService.focusPopoutWindow();
      }
    }
  }
}


@Component({
  selector: 'app-drive-connect-dialog-component',
  templateUrl: './drive-connect-dialog.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DriveConnectDialogComponent implements OnInit {
  public appName: string = environment.applicationName.charAt(0).toUpperCase() + environment.applicationName.slice(1);
  private positionRelativeToElement: any;
  public windowWidth = window.innerWidth;

  constructor(
    private dialog: MatDialog, public dialogRef: MatDialogRef<DriveConnectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public options: { positionRelativeToElement: ElementRef }, public dashboardService: DashboardService) {
    this.positionRelativeToElement = options.positionRelativeToElement;
    this.dashboardService.closeDriveConnect.subscribe(data => {
      if (data && data === 'close') {
        this.dialogRef.close();
      }
    });
  }

  ngOnInit() {
    const matDialogConfig = new MatDialogConfig();
    const rect = this.positionRelativeToElement.getBoundingClientRect();
    if (window.innerWidth > 768) {
      matDialogConfig.position = rect && rect.y && rect.y < 125 ? { left: `${rect.left - 100}px`, top: `${rect.bottom + 25}px` }
        : { left: `${rect.left - 100}px`, top: `${rect.bottom - 125}px` };
      if (rect.right && (rect.right + rect.width > window.innerWidth)) {
        matDialogConfig.position = rect && rect.y && rect.y < 125 ? { top: `${rect.bottom + 25}px` }
          : { top: `${rect.bottom - 125}px` };
      }
      if (rect.left && rect.left < 0) {
        matDialogConfig.position = rect && rect.y && rect.y < 125 ? { left: `${rect.left + 10}px`, top: `${rect.bottom + 25}px` }
          : { left: `${rect.left + 10}px`, top: `${rect.bottom - 125}px` };
      }
      if (rect.left && (((rect.left + 450) > window.innerWidth))) {
        matDialogConfig.position = rect && rect.y && rect.y < 125 ? { left: `${window.innerWidth - 500}px`, top: `${rect.bottom + 25}px` }
          : { left: `${window.innerWidth - 500}px`, top: `${rect.bottom - 125}px` };
      }
      if (rect.y && (((rect.y + 260) > window.innerHeight))) {
        matDialogConfig.position = rect && rect.y && rect.y < 125 ? { left: `${window.innerWidth - 500}px`, top: `${rect.bottom + 25}px` }
          : { left: `${rect.left + 10}px`, top: `${rect.y - 270}px` };
      }
    }
    this.dialogRef.updatePosition(matDialogConfig.position);
  }

  close(): void {
    this.dialogRef.close();
  }

}
